import clsx from 'clsx';
import {AnchorHTMLAttributes, ButtonHTMLAttributes, FC, MouseEventHandler, ReactNode, RefObject, SVGProps} from 'react';
import Loader, {ILoaderProps, LOADER_SIZES} from '@/ui/Loader';
import styles from './styles.module.scss';

export enum BTN_TAGS {
    button = 'button',
    a = 'a'
}

export enum BTN_TYPES {
    regular = styles.regular,
    outline = styles.outline,
    opacity = styles.opacity
}

export interface IButtonProps {
    Icon?: FC<SVGProps<SVGSVGElement>> | null;
    children?: ReactNode;
    ButtonTag?: BTN_TAGS;
    btnType?: BTN_TYPES;
    disabled?: boolean;
    loading?: boolean;
    onClick?: MouseEventHandler<HTMLButtonElement> & MouseEventHandler<HTMLAnchorElement>;
    btnProps?: ButtonHTMLAttributes<HTMLButtonElement> & AnchorHTMLAttributes<HTMLAnchorElement>;
    btnRef?: (RefObject<HTMLButtonElement | null> & RefObject<HTMLAnchorElement | null>) | null;
    btnStyles?: string[];
    iconProps?: SVGProps<SVGSVGElement>;
    loaderProps?: ILoaderProps;
}

const Button = ({
    Icon = null,
    children = null,
    ButtonTag = BTN_TAGS.button,
    btnType = BTN_TYPES.regular,
    onClick = () => {},
    disabled = false,
    loading = false,
    btnRef = null,
    btnProps = {},
    btnStyles = [],
    iconProps = {},
    loaderProps = {}
}: IButtonProps) => {
    return (
        <ButtonTag
            ref={btnRef}
            className={clsx(styles.button, btnType, ...btnStyles)}
            onClick={onClick}
            disabled={disabled || loading}
            {...btnProps}
        >
            {loading && (
                <Loader loading={loading} size={LOADER_SIZES.sm} loaderStyles={[styles.loader]} {...loaderProps} />
            )}
            {!!Icon && <Icon {...iconProps} />}
            {children}
        </ButtonTag>
    );
};

export default Button;
